const MY_BUSINESS = ({ merchantId }) => ({
  title: 'sidemenu.popover_items.myBusiness',
  action: () => {
    window.open(`${process.env.VUE_APP_COMPANY_URL}/${merchantId}`, '_blank')
  }
})

const MY_PROFILE = () => ({
  title: 'sidemenu.popover_items.myProfile',
  action: () => {
    window.open(`${process.env.VUE_APP_PROFILE_URL}`, '_blank', 'noopener')
  }
})

const EXIT = ({ toggleGlobalLoading, DELETE_AUTHORIZATION }) => ({
  title: 'sidemenu.popover_items.exit',
  action: () => {
    toggleGlobalLoading(true)
    DELETE_AUTHORIZATION(true)
  }
})

const ACCES_BACKOFFICE = () => ({
  title: 'sidemenu.popover_items.accesBackoffice',
  action: () => {
    window.open(`${process.env.VUE_APP_BACKOFFICE_URL}`, '_blank')
  }
})

/**
 * @param {Object} args
 * @returns Array<Object>
 */
const ITEMS_NOT_EMPLOYEE = args =>
  [MY_BUSINESS, MY_PROFILE, EXIT].map(item => item(args))

/**
 * @param {Object} args
 * @returns Array<Object>
 */
const ITEMS_EMPLOYEE = args => [ACCES_BACKOFFICE].map(item => item(args))

/**
 * @param {Object} args
 * @param {Boolean} isEmployee
 * @returns Array<Object>
 */
const ITEMS_POPOVER = (isEmployee, args) => {
  const items = ITEMS_NOT_EMPLOYEE(args)

  if (!isEmployee) {
    return items
  }

  return [...ITEMS_EMPLOYEE(args), ...items]
}

export { ITEMS_EMPLOYEE, ITEMS_NOT_EMPLOYEE, ITEMS_POPOVER }
